import { useEffect, useRef } from 'react';
import { IDepartments } from '../../../../../interface/interfaces';
import { useReactFlow } from '@xyflow/react';

export const useCreateAndConnect = (
    rootDepartment: IDepartments,
    inDepartment: IDepartments[],
    outDepartment: IDepartments[],
    onAdd: (node: IDepartments, num: number) => void,
    connectEdges: (source: IDepartments, target: IDepartments, output: boolean) => void,
    clearEdges: () => void,
    clearNodes: () => void,
) => {
    const initialized = useRef(false);
    const { fitView } = useReactFlow();

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            return;
        }

        if (rootDepartment && (inDepartment.length > 0 || outDepartment.length > 0)) {
            // Clear nodes and edges
            clearNodes();
            clearEdges();

            // Adding nodes and connect edges for IN
            inDepartment.forEach((dep: IDepartments, idx: number) => {
                onAdd(dep, idx);
                connectEdges(dep, rootDepartment, false);
            });

            // Adding nodes and connect edges for ROOT
            onAdd(rootDepartment, 0);

            // Adding nodes and connect edges for OUT
            outDepartment.forEach((dep: IDepartments, idx: number) => {
                onAdd(dep, idx);
                connectEdges(rootDepartment, dep, true);
            });
        }
        fitView();
    }, [inDepartment, outDepartment, rootDepartment, onAdd, connectEdges, clearEdges, clearNodes]);
};
